import type { Route } from "./+types/navigation.layout";

import { Suspense, useEffect, useState } from "react";
import { Await, Outlet } from "react-router";

import {
  AUTH_STATE_CHANGE_EVENT,
  getUserInfo,
  isLoggedIn,
  logout,
} from "~/features/auth/api/auth-api";

import Footer from "../components/footer";
import { NavigationBar } from "../components/navigation-bar";
import makeServerClient from "../lib/supa-client.server";

export async function loader({ request }: Route.LoaderArgs) {
  const [client] = makeServerClient(request);
  const userPromise = client.auth.getUser();
  return { userPromise };
}

export default function NavigationLayout({ loaderData }: Route.ComponentProps) {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [tnmtName, setTnmtName] = useState<any>(null);

  // 컴포넌트 마운트 시 localStorage에서 사용자 정보 가져오기
  useEffect(() => {
    const storedTnmtName = localStorage.getItem("tnmtName");
    if (storedTnmtName) {
      setUserLoggedIn(true);
    }
  }, []);

  // userLoggedIn 상태 변경 감지
  useEffect(() => { }, [userLoggedIn]);

  // 로그인 상태 업데이트 함수
  const updateAuthState = () => {
    const isLogIn = isLoggedIn();
    setUserLoggedIn(isLogIn);

    if (isLogIn) {
      const userInfo = getUserInfo();
      setTnmtName(userInfo);
    } else {
      setTnmtName(null);
      localStorage.removeItem("tnmtName");
    }
  };

  // 컴포넌트 마운트 시 로그인 상태 및 유저 정보 확인
  useEffect(() => {
    updateAuthState();

    // 로그인 상태 변경 이벤트 리스너 등록
    const handleAuthStateChange = (
      event: CustomEvent<{ isLoggedIn: boolean; user?: any }>,
    ) => {
      setUserLoggedIn(event.detail.isLoggedIn);
      setTnmtName(event.detail.user || null);
      // 이벤트 발생 시 localStorage도 업데이트
      if (event.detail.isLoggedIn && event.detail.user) {
        localStorage.setItem("tnmtName", JSON.stringify(event.detail.user));
      } else {
        localStorage.removeItem("tnmtName");
      }
    };

    window.addEventListener(
      AUTH_STATE_CHANGE_EVENT,
      handleAuthStateChange as EventListener,
    );

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener(
        AUTH_STATE_CHANGE_EVENT,
        handleAuthStateChange as EventListener,
      );
    };
  }, []);

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    logout();
    // logout 함수 내에서 이벤트를 발생시키므로 여기서는 상태 업데이트 불필요
  };
  const { userPromise } = loaderData;
  return (
    <div className="flex min-h-screen flex-col justify-between">
      {userLoggedIn ? (
        <NavigationBar
          name={tnmtName || "Anonymous"}
          loading={false}
          isLoggedIn={userLoggedIn}
        />
      ) : (
        <NavigationBar
          name={tnmtName || "Anonymous"}
          loading={false}
          isLoggedIn={userLoggedIn}
        />
      )}
      <div className="mx-auto my-16 w-full max-w-screen-2xl px-5">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
